import { useState } from "react";
import {
  GoabBlock,
  GoabCheckbox,
  GoabFormItem,
  GoabInput,
} from "@abgov/react-components";

import { useGenerationForm } from "../../../../hooks";

import { formatPhoneNumber } from "../../../../../../../MPP-Common-SPA/utils/globalUtility";

export const PhoneNumberETransfer = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleChange,
    handlePaymentInformationMobileAndPhoneChange,
    handleBlur,
    isReady,
  } = useGenerationForm("PaymentInformation");

  // Keys used to re-render inputs to update number formatting.
  const [mobileInputKey, setMobileInputKey] = useState(0);
  const [confirmMobileInputKey, setConfirmMobileInputKey] = useState(0);

  // Early return if form not ready.
  if (!isReady) return null;

  const mobileError = fieldTouches.mobile && fieldErrors.mobile;
  const confirmMobileError =
    fieldTouches.confirmMobile && fieldErrors.confirmMobile;

  return (
    <GoabBlock direction="column" gap="s">
      <GoabFormItem>
        <GoabCheckbox
          name="usePersonalNumber"
          text="Use my phone number from primary contact information"
          onChange={({name, value}) => {
            handlePaymentInformationMobileAndPhoneChange(name!, value);
            setTimeout(() => form.validateForm(), 0);
          }}
          checked={fieldValues.usePersonalNumber}
        ></GoabCheckbox>
      </GoabFormItem>
      <GoabFormItem
        label="Mobile phone number"
        helpText="This is your 10-digit Canadian mobile phone number"
        error={fieldErrors.mobile}
      >
        <GoabInput
          key={`mobile-${mobileInputKey}`}
          name="mobile"
          type="text"
          value={fieldValues.mobile}
          onChange={({name, value}) => {
            if (fieldValues.usePersonalNumber) {
              handlePaymentInformationMobileAndPhoneChange(name, value);
            } else {
              const number = formatPhoneNumber(value);
              if (number !== value && number.length >= 10) {
                setMobileInputKey((inputKey) => inputKey + 1);
                setTimeout(() => form.validateForm());
              }
              handleChange(name, number);
            }
          }}
          onBlur={() => {
            handleBlur("mobile");
            handleBlur("confirmMobile");
          }}
          disabled={fieldValues.usePersonalNumber}
          width="18.5ch"
          error={!!mobileError}
        ></GoabInput>
      </GoabFormItem>
      <GoabFormItem
        mt="m"
        label="Confirm mobile phone number"
        error={fieldErrors.confirmMobile}
      >
        <GoabInput
          key={`confirmMobile-${confirmMobileInputKey}`}
          name="confirmMobile"
          type="text"
          value={fieldValues.confirmMobile}
          onChange={({name, value}) => {
            if (fieldValues.usePersonalNumber) {
              handlePaymentInformationMobileAndPhoneChange(name, value);
            } else {
              const number = formatPhoneNumber(value);
              if (number !== value && number.length >= 10) {
                setConfirmMobileInputKey((inputKey) => inputKey + 1);
                setTimeout(() => form.validateForm());
              }
              handleChange(name, number);
            }
          }}
          onBlur={() => {
            handleBlur("mobile");
            handleBlur("confirmMobile");
          }}
          disabled={fieldValues.usePersonalNumber}
          width="18.5ch"
          error={!!confirmMobileError}
        ></GoabInput>
      </GoabFormItem>
    </GoabBlock>
  );
};
